import * as React from 'react';

import { branch, compose } from 'recompose';

import inServerContext from 'bundles/ssr/util/inServerContext';
import DegreesCollectionsContext from 'bundles/unified-description-page-common/contexts/DegreesCollectionsContext';
import { useCoursePageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import withDegreeCollection from 'bundles/unified-description-page-common/hocs/collections/withDegreeCollection';
import type { PropsToComponent as PropsFromDegreeCollection } from 'bundles/unified-description-page-common/hocs/collections/withDegreeCollection';

type PropsToInnerProvider = PropsFromDegreeCollection & {
  children: React.ReactNode;
};

type PropsToDataFetcher = {
  domainId?: string;
  courseId?: string;
};

const DegreesCollectionsDataProviderInner = ({
  degreeCollection,
  degreeListLoading,
  children,
}: PropsToInnerProvider) => {
  return (
    <DegreesCollectionsContext.Provider
      value={{
        degrees: degreeCollection,
        degreeRecommendationsLoading: degreeListLoading,
      }}
    >
      {children}
    </DegreesCollectionsContext.Provider>
  );
};

const DegreesCollectionsDataFetcher = compose<PropsToInnerProvider, React.PropsWithChildren<PropsToDataFetcher>>(
  branch(() => !inServerContext, compose<{}, React.PropsWithChildren<{}>>(withDegreeCollection))
)(DegreesCollectionsDataProviderInner);

export const ConsumerDegreesProductCollectionsDataProvider = ({ children }: { children: React.ReactNode }) => {
  const pageData = useCoursePageData();

  return (
    <DegreesCollectionsDataFetcher domainId={pageData?.domains?.[0]?.domainId} courseId={pageData?.id}>
      {children}
    </DegreesCollectionsDataFetcher>
  );
};
